<template>
  <div class="notes-container">
    <p v-on:click="toggle()" class="close">FERMER MES NOTES</p>
    <textarea name="notes" v-model="innerText" @keyup="$emit('update', innerText)"></textarea>
  </div>
</template>

<script>
export default {
  name: "Notes",
  props: { content: String },
  data() {
    return {
      innerText: this.content
    };
  },
  methods: {
    toggle() {
      this.$emit("toggleNote");
    }
  }
};
</script>

<style scoped>
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.close {
  background: #68322c;
  text-align: center;
  font-family: "Libre Caslon Text", serif;
  color: white;
  margin: 0;
  width: calc(100% + 20px);
  line-height: 25px;
}
.close:hover {
  cursor: pointer;
}
.notes-container textarea {
  background-color: #f8f5de;
  background-image: linear-gradient(
    to right,
    rgba(255, 210, 0, 0.4),
    rgba(200, 160, 0, 0.1) 11%,
    rgba(0, 0, 0, 0) 35%,
    rgba(200, 160, 0, 0.1) 65%
  );

  box-shadow: inset 0 0 75px rgba(255, 210, 0, 0.3), inset 0 0 20px rgba(255, 210, 0, 0.4),
    inset 0 0 30px rgba(220, 120, 0, 0.8);
  color: rgb(80, 80, 80);
  font-family: "Libre Caslon Text", serif;
  font-size: 17px;
  padding: 10px;
  height: 100%;
  width: 100%;
  overflow: scroll;
}
textarea {
  border: none;
  overflow: auto;
  outline: none;

  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;

  resize: none; /*remove the resize handle on the bottom right*/
}
</style>
